import {
	SET_PRODUCT_ENTRY,
	RESET_PRODUCT_ENTRY,
	COMPLETE_STEP,
	RESET_STEPS
} from './mutations'

/**
 * The Actions
 * @type { Object}
 */
export default {
	setProductEntry({ commit }, payload) {
		commit(SET_PRODUCT_ENTRY, payload)
	},

	resetProductEntry({ commit }, payload){
		commit(RESET_PRODUCT_ENTRY, payload)
	},

	completeStep({ commit }, payload) {
		commit(COMPLETE_STEP, payload);
	},

	resetSteps({ commit }, payload) {
		commit(RESET_STEPS, payload);
	},
};


// WEBPACK FOOTER //
// ./src/store/product/actions.js